import React, { useEffect, useState } from 'react';
import HealthBar from './components/HealthBar';
import VerifyTester from './components/VerifyTester';

export default function App() {
  const [tab, setTab] = useState('verify');

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header tab={tab} setTab={setTab} />
      <HealthBar />
      <main style={{ flex: 1, padding: '24px', maxWidth: 960, width: '100%', margin: '0 auto' }}>
        {tab === 'verify' && <VerifyTester />}
        {tab === 'about' && <About />}
      </main>
    </div>
  );
}

function Header({ tab, setTab }) {
  return (
    <header
      style={{
        borderBottom: '1px solid var(--border)',
        padding: '14px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: 24,
      }}
    >
      <h1 style={{ margin: 0, fontSize: 20, color: 'var(--green)' }}>
        blg-llm
      </h1>
      <span style={{ color: 'var(--text-dim)', fontSize: 13 }}>
        AI playground · Battle League Gaming
      </span>
      <div style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
        <TabButton active={tab === 'verify'} onClick={() => setTab('verify')}>
          Verify screenshot
        </TabButton>
        <TabButton active={tab === 'about'} onClick={() => setTab('about')}>
          About
        </TabButton>
      </div>
    </header>
  );
}

function TabButton({ active, children, onClick }) {
  return (
    <button
      onClick={onClick}
      className={active ? '' : 'secondary'}
      style={{ padding: '6px 12px', fontSize: 13 }}
    >
      {children}
    </button>
  );
}

function About() {
  const [supported, setSupported] = useState(null);
  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/api/supported-games`)
      .then(r => r.json())
      .then(setSupported)
      .catch(() => setSupported({ error: 'unreachable' }));
  }, []);

  return (
    <div>
      <h2 style={{ color: 'var(--green)', marginTop: 0 }}>What this is</h2>
      <p style={{ color: 'var(--text-dim)', maxWidth: 640 }}>
        A small admin/test surface for the blg-llm service. Use the
        <strong style={{ color: 'var(--text)' }}> Verify screenshot </strong>
        tab to throw an image at the model and see the verdict the BLG
        backend would receive at submit-score time.
      </p>
      <h3 style={{ color: 'var(--text)' }}>Supported games</h3>
      {supported && supported.games && (
        <ul>
          {supported.games.map(g => (
            <li key={g}>
              <strong>{g}</strong>
              {supported.aliases && supported.aliases[g]?.length > 0 && (
                <span style={{ color: 'var(--text-dim)' }}>
                  {' — aliases: '}
                  {supported.aliases[g].join(', ')}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
      {supported && supported.error && (
        <p style={{ color: 'var(--red)' }}>
          Could not reach blg-llm API. Is the service running?
        </p>
      )}
    </div>
  );
}
